import PropTypes from 'prop-types';

// Título de sección al estilo nido.cl: mayúsculas, centrado y flanqueado por dos líneas finas
export default function SectionTitle({ children, tone = 'dark', as: Tag = 'h2' }) {
  const isLight = tone === 'light';
  return (
    <div className="flex items-center gap-6 md:gap-10">
      <span className={`hidden sm:block h-px flex-1 ${isLight ? 'bg-white/40' : 'bg-gray-400'}`} aria-hidden="true" />
      <Tag className={`text-center text-2xl md:text-4xl font-semibold uppercase tracking-wide ${isLight ? 'text-white' : 'text-green-900'}`}>
        {children}
      </Tag>
      <span className={`hidden sm:block h-px flex-1 ${isLight ? 'bg-white/40' : 'bg-gray-400'}`} aria-hidden="true" />
    </div>
  );
}

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
  tone: PropTypes.oneOf(['dark', 'light']),
  as: PropTypes.elementType,
};
